/// <reference path="../typings/index.d.ts" />
namespace App {
  export class TopSniperDiego {
    private urlUpdateFiltro: string = null
    public configuracoes: any = null
    public topCartasMomento: ICartaTopSniper[] = [];
    private static excludesAssetId: any = [5740, 1605, 238384, 190871]
    private static excludesRareFlag: any = [76]

    constructor(urlUpdateFiltro: string) {
      this.urlUpdateFiltro = urlUpdateFiltro

      this.configuracoes = {
        preco_minimo_cartas: 100000,
        lucro_condicional_entrar_top_cartas: 20000, // lucro geral obtido com a carta para podendo salvar o filtro

        id_filtro_automatico_cx_baixo: 65977,
        id_filtro_automatico_cx_medio_1: 65979,
        id_filtro_automatico_cx_medio_2: 65980,
        id_filtro_automatico_cx_alto: 65981,
        //IMPORTANTE: preco_compra_fixo_filtro_dinamico tem que ser menor que preco_condicional_entrar_top_cartas
        //preco_condicional_entrar_top_cartas: 30000, // preco de venda minimo da carta para entrar podendo salvar o filtro
        preco_compra_carta_especial_cx_baixo: 100000, // preco de compra que será salvo no filtro
        preco_compra_carta_especial_cx_medio: 150000, // preco de compra que será salvo no filtro
        preco_compra_carta_especial_cx_alto: 300000, // preco de compra que será salvo no filtro
        preco_variacao_filtro_automatico_1: 10, // variação de preço que será salvo no filtro
        preco_variacao_filtro_automatico_2: 6, // variação de preço que será salvo no filtro
        usar_filtro_qualidade: false
      };
    }

    public async validarRegrasUrlCarregada(urlAtual: string): Promise<string> {

      return null
    }

    public iniciarRecarregamento() {
      window.location.replace('https://futsniperweb.com.br/admin/top-sniper')
    }

    /**
     * Condição para as cartas certas que considero importantes está em minha análise
     * @param objTopCarta
     */
    public condicaoTopCartasImportantes(objTopCarta: ICartaTopSniper) {
      if (objTopCarta.quantidade_mais >= 1 && objTopCarta.preco > this.configuracoes.preco_minimo_cartas
        && objTopCarta.lucro > this.configuracoes.lucro_condicional_entrar_top_cartas
        && !TopSniperDiego.excludesAssetId.includes(parseInt(objTopCarta.asset_id as any)) && !TopSniperDiego.excludesRareFlag.includes(parseInt(objTopCarta.rareflag as any))) {
        this.topCartasMomento.push(objTopCarta)
      }
    }

    public async prepararTopCartas() {
      TopSniperUtil.logTopSniper("TOP_CARTAS DIEGO", this.topCartasMomento);
      this.topCartasMomento = await Promise.all(this.topCartasMomento.map(async (item: ICartaTopSniper) => ({ ...item, player_info: await TopSniperUtil.filtrarPlayerInfoOrg(item.nome, item.resource_id) })));
      this.topCartasMomento.sort((a: any, b: any) => {
        if (b.quantidade_mais !== a.quantidade_mais) {
          return b.quantidade_mais - a.quantidade_mais;
        }
        return b.lucro - a.lucro; // desempate por lucro
      });
      // coloquei a linha e cima e comentei a de baixo, substituindo
      //this.topCartasMomento.sort((a: any, b: any) => b.lucro - a.lucro);
      TopSniperUtil.logTopSniper('TOP_CARTAS_ORDER DIEGO', this.topCartasMomento);
      this.metodoTopCartasAdminDiego();
    }

    public async processarTopCartasPilotoPrincipalPorQualidade(cartasEspeciaisCxMedio: ICartaTopSniper[], cartasEspeciaisCxAlto: ICartaTopSniper[]) {
      if (cartasEspeciaisCxMedio.length) {
        TopSniperUtil.salvarFiltroPiloto(this.urlUpdateFiltro, {
          id: this.configuracoes.id_filtro_automatico_cx_medio_1,
          variar: this.configuracoes.preco_variacao_filtro_automatico_2,
          maxBuyNow: this.configuracoes.preco_compra_carta_especial_cx_medio ? this.configuracoes.preco_compra_carta_especial_cx_medio : TopSniperUtil.getMenorPreco(cartasEspeciaisCxMedio[0].valor_all),
          maskedDefId: [cartasEspeciaisCxMedio[0].asset_id],
          quality: "SP"
        })
        if (cartasEspeciaisCxMedio.length > 1) {
          TopSniperUtil.salvarFiltroPiloto(this.urlUpdateFiltro, {
            id: this.configuracoes.id_filtro_automatico_cx_medio_2,
            variar: this.configuracoes.preco_variacao_filtro_automatico_2,
            maxBuyNow: this.configuracoes.preco_compra_carta_especial_cx_medio ? this.configuracoes.preco_compra_carta_especial_cx_medio : TopSniperUtil.getMenorPreco(cartasEspeciaisCxMedio[1].valor_all),
            maskedDefId: [cartasEspeciaisCxMedio[1].asset_id],
            quality: "SP"
          })
        }
      }

      if (cartasEspeciaisCxAlto.length) {
        TopSniperUtil.salvarFiltroPiloto(this.urlUpdateFiltro, {
          id: this.configuracoes.id_filtro_automatico_cx_alto,
          variar: this.configuracoes.preco_variacao_filtro_automatico_2,
          maxBuyNow: this.configuracoes.preco_compra_carta_especial_cx_alto ? this.configuracoes.preco_compra_carta_especial_cx_alto : TopSniperUtil.getMenorPreco(cartasEspeciaisCxAlto[0].valor_all),
          maskedDefId: [cartasEspeciaisCxAlto[0].asset_id],
          quality: "SP"
        })
      }
    }

    public async processarTopCartasPilotoPrincipalPorRaridade(cartasEspeciaisCxMedio: ICartaTopSniper[], cartasEspeciaisCxAlto: ICartaTopSniper[]) {
      if (cartasEspeciaisCxMedio.length) {
        TopSniperUtil.salvarFiltroPiloto(this.urlUpdateFiltro, {
          id: this.configuracoes.id_filtro_automatico_cx_medio_1,
          variar: this.configuracoes.preco_variacao_filtro_automatico_2,
          maxBuyNow: this.configuracoes.preco_compra_carta_especial_cx_medio ? this.configuracoes.preco_compra_carta_especial_cx_medio : TopSniperUtil.getMenorPreco(cartasEspeciaisCxMedio[0].valor_all),
          maskedDefId: [cartasEspeciaisCxMedio[0].asset_id],
          rarity: [cartasEspeciaisCxMedio[0].raridade.id]
        })
        if (cartasEspeciaisCxMedio.length > 1) {
          TopSniperUtil.salvarFiltroPiloto(this.urlUpdateFiltro, {
            id: this.configuracoes.id_filtro_automatico_cx_medio_2,
            variar: this.configuracoes.preco_variacao_filtro_automatico_2,
            maxBuyNow: this.configuracoes.preco_compra_carta_especial_cx_medio ? this.configuracoes.preco_compra_carta_especial_cx_medio : TopSniperUtil.getMenorPreco(cartasEspeciaisCxMedio[1].valor_all),
            maskedDefId: [cartasEspeciaisCxMedio[1].asset_id],
            rarity: [cartasEspeciaisCxMedio[1].raridade.id]
          })
        }
      }

      if (cartasEspeciaisCxAlto.length) {
        TopSniperUtil.salvarFiltroPiloto(this.urlUpdateFiltro, {
          id: this.configuracoes.id_filtro_automatico_cx_alto,
          variar: this.configuracoes.preco_variacao_filtro_automatico_2,
          maxBuyNow: this.configuracoes.preco_compra_carta_especial_cx_alto ? this.configuracoes.preco_compra_carta_especial_cx_alto : TopSniperUtil.getMenorPreco(cartasEspeciaisCxAlto[0].valor_all),
          maskedDefId: [cartasEspeciaisCxAlto[0].asset_id],
          rarity: [cartasEspeciaisCxAlto[0].raridade.id]
        })
      }
    }

    private aplicarFiltro(limiteValor: number): ICartaTopSniper[] {
      return this.topCartasMomento
        .filter(ele => {
          const precoCompraCalculado = this.calcularMaxBuyNow(ele);
          return ele.lucro > 30000 && ele.preco >= 50000 && ele.valor < limiteValor && precoCompraCalculado >= ele.valor;
        })
        .sort((a, b) => b.quantidade_mais - a.quantidade_mais ||
          b.total - a.total ||
          b.valor - a.valor ||
          b.preco - a.preco);
    }

    private filtrarTopCartas(): ICartaTopSniper[] {
      const resultado = this.aplicarFiltro(300000); // Teto unificado de 300k
      return resultado.slice(0, 4);
    }

    private async metodoTopCartasAdminDiego() {

      TopSniperUtil.logTopSniper('CARTAS CAINDO DENTRO DA REGRA', this.topCartasMomento);

      const cartasFiltradas = this.filtrarTopCartas();
      TopSniperUtil.logTopSniper('cartas filtradas', cartasFiltradas);

      if (!cartasFiltradas.length) return;

      const cartasValidas = this.getCartasDentroDoLimite(cartasFiltradas, 300000);

      if (!cartasValidas.length) {
        console.log('Nenhuma carta dentro do limite de coins');
        return;
      }

      this.aplicarFiltrosNasCartas(cartasValidas);
    }

    private getCartasDentroDoLimite(cartas: ICartaTopSniper[], limiteCoins: number): ICartaTopSniper[] {

      const cartasValidas: ICartaTopSniper[] = [];

      for (const carta of cartas) {

        const max = this.calcularMaxBuyNow(carta);
        console.log(`Carta ${carta.nome} max calculado:`,max);

        if (max <= limiteCoins) {
          cartasValidas.push(carta);
        }

        if (cartasValidas.length === 4) break;
      }

      return cartasValidas;
    }

    private aplicarFiltrosNasCartas(cartas: ICartaTopSniper[]) {
      const idsFiltros = [
        this.configuracoes.id_filtro_automatico_cx_baixo,
        this.configuracoes.id_filtro_automatico_cx_medio_1,
        this.configuracoes.id_filtro_automatico_cx_medio_2,
        this.configuracoes.id_filtro_automatico_cx_alto
      ];

      for (let i = 0; i < 4; i++) {
        const carta = cartas[i];
        if (carta) {
          console.log(`Slot ${i + 1} - salvou carta: ${carta.nome}`);
          this.processarCarta(carta, idsFiltros[i]);
        }
      }
    }

    private processarCarta(carta: ICartaTopSniper, idFiltro: number) {

      const valorCompraCarta = this.calcularMaxBuyNow(carta);
      const variacao = this.getVariacaoFiltro(valorCompraCarta);

      TopSniperUtil.salvarFiltroPiloto(this.urlUpdateFiltro, {
        id: idFiltro,
        variar: variacao,
        maxBuyNow: valorCompraCarta,
        maskedDefId: [carta.asset_id],
        rarity: [carta.raridade.id]
      });
    }

    private calcularMaxBuyNow(carta: ICartaTopSniper): number {
      // Regra: 60% do valor de mercado (preco), com teto de 300.000
      const precoSessentaPorCento = Math.floor(carta.preco * 0.60);
      const precoComVariacao = Util.getPrecoVariacaoMax(precoSessentaPorCento, 2);
      return Math.min(precoComVariacao, 300000);
    }

    private getValorMaisFrequente(valorAll: string, valorPadrao: number): number {

      if (!valorAll) return valorPadrao;

      const valores = valorAll
        .split(',')
        .map(v => parseInt(v.trim()))
        .filter(v => !isNaN(v));

      if (!valores.length) return valorPadrao;

      const contagem: Record<number, number> = {};

      for (const v of valores) {
        contagem[v] = (contagem[v] || 0) + 1;
      }

      let maisFreq = valores[0];
      let maior = 0;

      for (const v in contagem) {
        if (contagem[v] > maior) {
          maior = contagem[v];
          maisFreq = Number(v);
        }
      }

      return maisFreq || valorPadrao;
    }

    private getVariacaoFiltro(valor: any) {
      switch (true) {
        case valor <= 70000:
          return 10;
        case valor <= 110000:
          return 5;
        default:
          return 4;
      }
    }

    //METODOS ADMIN DIEGOOOOOL
    private async metodoTopCartasAdminDiegoOld() {
      let cartasQualidadeEspeciaiscartasEspeciaisCxMedio: ICartaTopSniper[] = []
      let cartasQualidadeEspeciaiscartasEspeciaisCxAlto: ICartaTopSniper[] = []
      let porcentagemLucro = 0.2; //10% de lucro

      let cartasCxBaixo: ICartaTopSniper[] = this.topCartasMomento.filter((ele: any) => {
        const ehEspecial = ele.raridade.id >= 1;
        const precoBomCompra = ele.valor <= this.configuracoes.preco_compra_carta_especial_cx_baixo;
        const dentroMargemLucro = ele.preco > (this.configuracoes.preco_compra_carta_especial_cx_baixo * 1.3);

        return ehEspecial && precoBomCompra && dentroMargemLucro;
      });

      let cartasEspeciaisCxMedio: ICartaTopSniper[] = this.topCartasMomento.filter((ele: any) => {
        const ehEspecial = ele.raridade.id >= 1;
        const precoBomCompra = ele.valor <= this.configuracoes.preco_compra_carta_especial_cx_medio;
        const dentroMargemLucro = ele.preco > (this.configuracoes.preco_compra_carta_especial_cx_medio * 1.3);

        return ehEspecial && precoBomCompra && dentroMargemLucro;
      });

      let cartasEspeciaisCxAlto: ICartaTopSniper[] = this.topCartasMomento.filter((ele: any) => {
        const ehEspecial = ele.raridade.id >= 1;
        const precoBomCompra = ele.valor <= this.configuracoes.preco_compra_carta_especial_cx_alto;
        const dentroMargemLucro = ele.preco > (this.configuracoes.preco_compra_carta_especial_cx_alto * 1.3);

        return ehEspecial && precoBomCompra && dentroMargemLucro;
      });

      if (this.configuracoes.usar_filtro_qualidade) {
        cartasQualidadeEspeciaiscartasEspeciaisCxMedio = await TopSniperUtil.filtrarCartasQualidadeEspecialCompativelFiltro(cartasEspeciaisCxMedio, this.configuracoes.preco_variacao_filtro_automatico_2)
        cartasQualidadeEspeciaiscartasEspeciaisCxAlto = await TopSniperUtil.filtrarCartasQualidadeEspecialCompativelFiltro(cartasEspeciaisCxAlto, this.configuracoes.preco_variacao_filtro_automatico_2)
      }

      if (cartasCxBaixo.length) {
        const config = this.configuracoes;
        const maxBuyNow = config.preco_compra_carta_especial_cx_baixo ? config.preco_compra_carta_especial_cx_baixo : TopSniperUtil.getMenorPreco(cartasCxBaixo[0].valor_all);
        const assetIds = [cartasCxBaixo[0].asset_id];

        TopSniperUtil.salvarFiltroPiloto(this.urlUpdateFiltro, {
          id: config.id_filtro_automatico_cx_baixo,
          variar: config.preco_variacao_filtro_automatico_1,
          maxBuyNow: maxBuyNow,
          maskedDefId: assetIds,
          rarity: [cartasCxBaixo[0].raridade.id]
        });
      }

      if (this.configuracoes.usar_filtro_qualidade) {
        this.processarTopCartasPilotoPrincipalPorQualidade(cartasQualidadeEspeciaiscartasEspeciaisCxMedio, cartasQualidadeEspeciaiscartasEspeciaisCxAlto)
      } else {
        this.processarTopCartasPilotoPrincipalPorRaridade(cartasEspeciaisCxMedio, cartasEspeciaisCxAlto)
      }
    }

  }
}
